import { apiSlice } from '../../app/api/apiSlice'

export const poApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseOrderTemplate: builder.query ({
      query: ({draft_id = null, type = null}) => draft_id !== null ? `v1/po/form?draft_id=${draft_id}&type=${type}` : `v1/po/form?type=${type}`,
      keepUnusedDataFor: 5
    }),
    updatePurchaseOrderData: builder.mutation ({
        query: (data) => ({
        url: `v1/po/update`,
        method: 'POST',
        body: data
        })
    }),
    updatePurchaseOrderDataAction: builder.mutation ({
      query: ({data, action}) => ({
      url: `v1/po/update/${action}`,
      method: 'POST',
      body: data
      })
    }),
    savePurchaseOrderDraft: builder.mutation ({
      query: (data) => ({
        url:`v1/po/savedraft`,
        method: 'PUT',
        body: data
      })
    }),
    savePurchaseOrder: builder.mutation ({
      query: (data) => ({
        url:`v1/po/submit`,
        method: 'PUT',
        body: data
      })
    }),
    getPurchaseOrderDraft: builder.query ({
      query: (draftId) => ({
        url: `v1/po/getdraft?draft_id=${draftId}`
      })
    }),
    getPurchaseOrder: builder.query ({
      query: (draftId) => ({
        url: `v1/po/getorder?draft_id=${draftId}`
      })
    }),
    sendPurchaseOrderAction: builder.mutation ({
      query: (action_id) => ({
        url: `v1/po/orderaction/${action_id}`,
        method: 'GET'
      })
    }),
    recachePOSheet: builder.mutation ({
      query: () => ({
        url: `v1/po/recache`,
        method: 'GET'
      })
    }),
    downloadMzkord: builder.mutation ({
      query: (order_id) => ({
        url: `v1/po/${order_id}/download_mzkord`,
        method: 'GET',
        responseHandler: (response) => response.blob()
      })
    }),
    uploadJobData: builder.mutation ({
      query: ({order_id, data}) => ({
        url: `v1/po/${order_id}/upload_jobdata`,
        method: 'POST',
        body: data
      })
    }),
    createFromJobData: builder.mutation ({
      query: ({data}) => ({
        url: `v1/po/create_from_jobdata`,
        method: 'POST',
        body: data
      })
    }),
    updateFromJobData: builder.mutation ({
      query: ({order_id, data}) => ({
        url: `v1/po/${order_id}/update_from_jobdata`,
        method: 'POST',
        body: data
      })
    }),
    resetJobData: builder.mutation ({
      query: ({order_id}) => ({
        url: `v1/po/${order_id}/reset_production`,
        method: 'GET'
      })
    })
  }),
})


export const {
  useGetPurchaseOrderTemplateQuery,
  useUpdatePurchaseOrderDataMutation,
  useUpdatePurchaseOrderDataActionMutation,
  useSavePurchaseOrderDraftMutation,
  useSavePurchaseOrderMutation,
  useGetPurchaseOrderDraftQuery,
  useGetPurchaseOrderQuery,
  useSendPurchaseOrderActionMutation,
  useRecachePOSheetMutation,
  useDownloadMzkordMutation,
  useUploadJobDataMutation,
  useCreateFromJobDataMutation,
  useUpdateFromJobDataMutation,
  useResetJobDataMutation
} = poApi
